import { Skeleton } from "@chakra-ui/react";
import { sizeMap } from "helpers/tag";

export default function SkeletonTag({ size }: { size?: "sm" | "md" }) {
  const { tagSizeProps } = sizeMap(size || "md");
  return (
    <Skeleton borderRadius="full" width="80px" height={tagSizeProps.height || "28px"} />
  );
}
